import { pipeline, env } from '@huggingface/transformers';
import { appState } from './appState';
import { t } from './i18n';
import { applyActiveSettings } from './settings';
import { updateUI } from './ui';
// Configure environment
env.allowLocalModels = false;
env.useBrowserCache = true;
env.remoteHost = 'https://huggingface.co';
export async function initializePipeline() {
    try {
        const modelStatus = document.getElementById('modelStatus');
        applyActiveSettings();
        if (!appState.nerPipeline) {
            // Skip model loading if remote models are disabled
            if (env.allowRemoteModels === false) {
                console.log('[Pipeline] Remote models disabled, skipping model load');
                if (modelStatus) {
                    modelStatus.innerHTML = `<span class="text-muted small fw-bold">Model loading disabled</span>`;
                }
                appState.isModelLoaded = false;
                return;
            }
            const modelStatus2 = document.getElementById('modelStatus');
            if (modelStatus2) {
                modelStatus2.innerHTML = `<span class="text-warning small fw-bold">${t('status.modelLoading') || 'Loading model...'}</span>`;
            }
            const modelName = 'Xenova/bert-base-multilingual-cased-ner-hrl';
            console.log('[Pipeline] Loading model:', modelName, 'from:', env.remoteHost);
            appState.nerPipeline = await pipeline('token-classification', modelName, {
                device: 'wasm',
                dtype: 'int8'
            });
        }
        appState.isModelLoaded = true;
        if (modelStatus) {
            modelStatus.innerHTML = `<span class="text-success small fw-bold">${t('status.modelReady')}</span>`;
        }
        updateUI();
    }
    catch (error) {
        const modelStatus = document.getElementById('modelStatus');
        console.error('[Pipeline] Failed to initialize pipeline:', error);
        if (modelStatus) {
            modelStatus.innerHTML = `<span class="text-muted small fw-bold">${t('status.modelError') || 'Model unavailable'}</span>`;
        }
        // Allow app to continue without NER - user can still use the app
        appState.isModelLoaded = false;
    }
}
